import {
  faChartMixed,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faCoin,
  faFlaskRoundPotion,
  faGearCode,
  faShieldCheck,
} from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import { selectOverlay } from 'ducks/overlays/selectors';
import { updateOverlay } from 'ducks/overlays/slices';
import { selectSettings } from 'ducks/settings/selectors';
import { PRIVATE } from 'router/routes';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { DRAWER_CLOSED, DRAWER_OPEN } from '../../constants';

import { DrawerAction } from './DrawerAction';
import { DrawerLink } from './DrawerLink';

import cn from './Drawer.module.scss';

export const Drawer = () => {
  const dispatch = useAppDispatch();
  const { offset_navigation } = useAppSelector(selectSettings);
  const { is_open } = useAppSelector(selectOverlay('drawer'));
  const width = is_open ? DRAWER_OPEN : DRAWER_CLOSED;
  return (
    <div
      className={classNames(cn.drawer, 'transition')}
      style={{ top: offset_navigation - 1, width, maxWidth: width }}
    >
      <DrawerLink to={PRIVATE.PAIRS.path} information="Pairs" icon={faCoin} />
      <DrawerLink to={PRIVATE.STRATEGIES.path} information="Strategies" icon={faFlaskRoundPotion} />
      <DrawerLink to={PRIVATE.BACKTESTS.path} information="Backtests" icon={faChartMixed} />
      <DrawerLink to={PRIVATE.CANDLE_WORKERS.path} information="Candle Workers" icon={faGearCode} />
      <DrawerLink
        to={PRIVATE.CANDLE_VALIDATIONS.path}
        information="Candle Validations"
        icon={faShieldCheck}
      />
      <div className={cn.flex} />
      <DrawerAction
        onClick={() => dispatch(updateOverlay({ key: 'drawer', data: { is_open: !is_open } }))}
        information={is_open ? 'Collapse' : 'Expand'}
        icon={is_open ? faChevronDoubleLeft : faChevronDoubleRight}
        border
      />
      <p className={cn.version}>{process.env.REACT_APP_VERSION}</p>
    </div>
  );
};
